import React, { useEffect, useRef } from 'react'
import TabContent from '../../TabContent.component'
import Need12 from "../../../assets/need-12.svg";

let css = `
    .active-tab{
        color: #fff;
        background-color: #174997;
    }
    .active-tab img{
        filter: invert(1);
    }
`;

export default function SswayamCrmProService() {
    let scrollRef = useRef();
    return (
        <>
            <section className="">
                <section>
                    <section>
                        <style>{css}</style>
                        <div className="flex mb-12 mt-0 max-w-[80%] justify-center mx-auto items-center">
                            <div
                                className=" p-5 max-h-[770px]  overflow-y-auto scroll-smooth"
                                ref={scrollRef}
                            >
                                <TabContent
                                    index={11}
                                    icon={Need12}
                                    // thumbnail={thumbImg}
                                    title={"Sswayam CRM Pro + (Service) CRM + Mobile App"}
                                    content={[
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam sem enim, pharetra nec neque et, pulvinar ultrices purus. Curabitur egestas a ipsum eu accumsan. Vestibulum malesuada sed nulla et aliquam. Interdum et malesuada fames ac ante ipsum primis in faucibus. Integer viverra pretium mi et commodo."
                                    ]}
                                    captionWidth={"200px"}
                                />
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </>
    )
}
